var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.87953 0.200195C4.70813 0.200195 0.519531 4.49474 0.519531 9.79694C0.519531 14.0435 3.19883 17.6303 6.91943 18.9019C7.38743 18.9858 7.56293 18.6979 7.56293 18.446C7.56293 18.2181 7.55123 17.4623 7.55123 16.6586C5.19953 17.1025 4.59113 16.0708 4.40393 15.531C4.29863 15.2551 3.84233 14.4034 3.44453 14.1755C3.11693 13.9955 2.64893 13.5517 3.43283 13.5397C4.16993 13.5277 4.69643 14.2354 4.87193 14.5233C5.71433 15.9749 7.05983 15.567 7.59803 15.3151C7.67993 14.6913 7.92563 14.2714 8.19473 14.0315C6.11213 13.7916 3.93593 12.9639 3.93593 9.29311C3.93593 8.24947 4.29863 7.38576 4.89533 6.71399C4.80173 6.47407 4.47413 5.4904 4.98893 4.17085C4.98893 4.17085 5.77283 3.91894 7.56293 5.15452C8.31173 4.93859 9.10733 4.83063 9.90293 4.83063C10.6985 4.83063 11.4941 4.93859 12.2429 5.15452C14.033 3.90694 14.8169 4.17085 14.8169 4.17085C15.3317 5.4904 15.0041 6.47407 14.9105 6.71399C15.5072 7.38576 15.8699 8.23747 15.8699 9.29311C15.8699 12.9759 13.682 13.7916 11.5994 14.0315C11.9387 14.3314 12.2312 14.9072 12.2312 15.8069C12.2312 17.0905 12.2195 18.1221 12.2195 18.446C12.2195 18.6979 12.395 18.9978 12.863 18.9019C16.5602 17.6303 19.2395 14.0315 19.2395 9.79694C19.2395 4.49474 15.0509 0.200195 9.87953 0.200195Z",
    fill: "#A0A0A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.82bae6589e9fc412a36a381fb3521824.svg";
export { ForwardRef as ReactComponent };